.e6{gap:0.25rem;}